import { Container } from "@mantine/core";

import type { ContainerProps } from "@mantine/core";
import type { FC } from "react";

export const ResponsivePageContainer: FC<ContainerProps> = ({
  children,
  size = "xl",
  px = { base: "md", md: "xl" },
  ...props
}) => {
  return (
    <Container size={size} px={px} pt="xl" {...props}>
      {children}
    </Container>
  );
};
